import { useState, useEffect } from 'react';
import MDCSwitch from '@material/react-switch';
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import PropTypes from 'prop-types';

import { CSS_CLASSES } from './_constants';
import './Toggle.scss';

const Toggle = props => {
	const [onKey, setOnKey] = useState(null);

	let appData = props.elementConfig.options[props.formElId].ApplicationData;

	useEffect(() => {
		for (let i = 0; i < appData.length; i++) {
			let key = appData[i].Value.toLowerCase();

			if (key === 'on') {
				setOnKey(key);
			} else {
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onChangeHandler = () => {
		setOnKey(onKey === 'off' ? 'on' : 'off');

		const event = {
			target: {
				id: 699,
				name: props.name,
				options: props.elementConfig.options,
				selectedIndex: '',
				value: onKey,
			},
		};
		props.changeHandler(event, true);
	};

	return (
		<StyleAuxiliary classes='mdc-form-field'>
			<MDCSwitch
				{...props}
				onChange={onChangeHandler}
				className={CSS_CLASSES.TOGGLE}
			/>
		</StyleAuxiliary>
	);
};

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/switch#props
Toggle.propTypes = {
	checked: PropTypes.bool,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	nativeControlId: PropTypes.string,
};

export default Toggle;
